import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReissue = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.56626 10.115V8.23032H5.824C7.12445 5.97809 9.55574 4.46089 12.3357 4.46089C15.8413 4.46089 18.7908 6.87333 19.6295 10.115L21.5708 10.115C20.6944 5.81788 16.8967 2.57617 12.3357 2.57617C9.25418 2.57617 6.51192 4.0651 4.79683 6.35503V4.46089H2.91211L2.91211 10.115H8.56626Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.1051 13.8848V15.7695H18.8474C17.5469 18.0217 15.1157 19.5389 12.3357 19.5389C8.83012 19.5389 5.88054 17.1265 5.04184 13.8848H3.10059C3.97698 18.1819 7.77468 21.4236 12.3357 21.4236C15.4172 21.4236 18.1595 19.9347 19.8746 17.6448V19.5389L21.7593 19.5389V13.8848H16.1051Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgReissue);
export default ForwardRef;
